var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.665497 4.06493H21.2632C22.8884 4.06493 24.2058 5.23808 24.2058 6.68523V16.5114C24.2058 17.9585 22.8884 19.1317 21.2632 19.1317H3.60803C1.98291 19.1317 0.665497 17.9585 0.665497 16.5114V4.06493Z",
    fill: "#6A84C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.665497 4.06493H21.2632C22.8884 4.06493 24.2058 5.23808 24.2058 6.68523V16.5114C24.2058 17.9585 22.8884 19.1317 21.2632 19.1317H3.60803C1.98291 19.1317 0.665497 17.9585 0.665497 16.5114V4.06493Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.665497 3.40985C0.665497 1.9627 1.98291 0.789551 3.60803 0.789551H8.02183C9.64695 0.789551 10.9644 1.9627 10.9644 3.40985V4.06493H0.665497V3.40985Z",
    fill: "#6A84C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.665497 3.40985C0.665497 1.9627 1.98291 0.789551 3.60803 0.789551H8.02183C9.64695 0.789551 10.9644 1.9627 10.9644 3.40985V4.06493H0.665497V3.40985Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.4c321515c8f1cfe1eff61bdd9ccbdf93.svg";
export { ForwardRef as ReactComponent };